import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Observable, of, timer } from 'rxjs';
import { finalize, map, switchMap } from 'rxjs/operators';

import {
  AuthService,
  AvlaRestClientService,
  UserInfoDTO,
} from 'base-angular-avla';
import {
  AvlaGenericComponent,
  I18nService,
  MessageService,
} from 'shared-angular-components-avla';

import { CountryOrigin } from 'app/core/models/pending-request-dto.model';
import { CountryDto } from '../core/models/country-dto.model';

@Injectable({
  providedIn: 'root',
})
export class CountriesService extends AvlaGenericComponent {
  static instance: CountriesService;

  public findCountriesUrl = '/api-mark-list/findCountries';
  public findByDefaultLanguage =
    '/api-mark-list/findCountriesWithDefaultLanguages';

  public isLoadingFindCountries = false;
  private countries: CountryDto[];

  constructor(
    protected messageService: MessageService,
    protected i18n: I18nService,
    protected router: Router,
    protected authService: AuthService,
    protected restClientService: AvlaRestClientService,
    protected datePipe: DatePipe
  ) {
    super(restClientService, messageService, router, authService, i18n);
    CountriesService.instance = CountriesService.instance || this;
    return CountriesService.instance;
  }

  public findAllCountries(): Observable<CountryDto[]> {
    return this.restClientService
      .getList(this.findCountriesUrl, null, null)
      .pipe(
        map(data => {
          this.countries = data;
          this.countries = this.countries.sort((a, b) =>
            a.name < b.name ? -1 : a.name > b.name ? 1 : 0
          );
          return this.countries;
        })
      );
  }

  public findCountries(): Observable<CountryDto[]> {
    if (this.isLoadingFindCountries) {
      return timer(2000).pipe(switchMap(() => this.findCountries()));
    }
    this.isLoadingFindCountries = true;
    if (this.countries) {
      this.isLoadingFindCountries = false;
      return of(this.countries);
    }
    return this.restClientService
      .getList(this.findCountriesUrl, null, null)
      .pipe(
        map(data => {
          this.countries = data;
          this.countries = this.countries.sort((a, b) =>
            a.name < b.name ? -1 : a.name > b.name ? 1 : 0
          );
          return this.countries;
        }),
        finalize(() => {
          this.isLoadingFindCountries = false;
        })
      );
  }

  private fetchAndSortCountries(): Observable<CountryOrigin[]> {
    return this.restClientService
      .getList(this.findByDefaultLanguage, null, null)
      .pipe(
        map(data => {
          this.countries = data;
          this.countries = this.countries.sort((a, b) =>
            a.name < b.name ? -1 : a.name > b.name ? 1 : 0
          );
          return this.countries;
        })
      );
  }

  public findCountriesWithDefaultLanguages(): Observable<CountryOrigin[]> {
    if (this.isLoadingFindCountries) {
      return timer(2000).pipe(
        switchMap(() => this.findCountriesWithDefaultLanguages())
      );
    }
    this.isLoadingFindCountries = true;
    if (this.countries) {
      this.isLoadingFindCountries = false;
      return of(this.countries);
    }
    return this.getCountriesWithDefaultLanguages().pipe(
      map(data => {
        return data;
      }),
      finalize(() => {
        this.isLoadingFindCountries = false;
      })
    );
  }

  public getCountriesWithDefaultLanguages(): Observable<CountryOrigin[]> {
    return this.fetchAndSortCountries();
  }

  public validateCountryCodeByGroup(
    countryCode: string,
    userInfoDto: UserInfoDTO
  ): boolean {
    if (
      !userInfoDto ||
      !userInfoDto.groups ||
      userInfoDto.groups.length === 0
    ) {
      return false;
    }
    if (userInfoDto.username === 'admin' && userInfoDto.id === 1) {
      return true;
    }

    for (let g of userInfoDto.groups) {
      if ('MARK-LIST - CL' === g.name && 'CL' === countryCode) {
        return true;
      } else if ('MARK-LIST - PE' === g.name && 'PE' === countryCode) {
        return true;
      } else if ('MARK-LIST - MX' === g.name && 'MX' === countryCode) {
        return true;
      } else if ('MARK-LIST - BR' === g.name && 'BR' === countryCode) {
        return true;
      }
    }
    return false;
  }
}
